import { createReducer } from '../helpers';

import { SidebarActionTypes } from '../actions/types';

const initialState = {
  isExpanded: false,
};

const sidebarReducer = createReducer(
  initialState,
  {
    [SidebarActionTypes.expandSidebar]: state => ({ ...state, isExpanded: true }),
    [SidebarActionTypes.collapseSidebar]: state => ({ ...state, isExpanded: false }),
  },
);

export default sidebarReducer;
